import { SerializedContent } from '@/features/screenplay/components/editor/utils/JsonUtils';
import http from '@/features/shared/http/client';
import { SceneGenerationOptions, ScreenplayOutlineGenerationOptions, ScreenplaySuggestionProps } from '../types';

export class ScreenplayAIService {

    async generateScreenplayOutline(options: ScreenplayOutlineGenerationOptions): Promise<SerializedContent[]> {
        try {
            const response = await http.post<{ result: SerializedContent[] }>('/generateScreenplayOutline', { data: options });
            return response.data.result;
        } catch (error) {
            console.error('Error generating screenplay outline:', error);
            throw error;
        }
    }

    async generateScene(options: SceneGenerationOptions): Promise<SerializedContent[]> {
        try {
            const response = await http.post<{ result: SerializedContent[] }>('/generateScene', { data: options });
            return response.data.result;
        } catch (error) {
            console.error('Error generating scene:', error);
            throw error;
        }
    }

    async modifyScene(options: SceneGenerationOptions): Promise<SerializedContent[]> {
        try {
            const response = await http.post<{ result: SerializedContent[] }>('/modifyScene', { data: options });
            return response.data.result;
        } catch (error) {
            console.error('Error modifying scene:', error);
            throw error;
        }
    }

    async generateScreenplaySuggestions(props: ScreenplaySuggestionProps): Promise<string> {
        try {
            const response = await http.post<{ result: string }>('/generateScreenplaySuggestions', { data: props });
            return response.data.result;
        } catch (error) {
            console.error('Error generating screenplay suggestions:', error);
            throw error;
        }
    }
}

export const screenplayAIService = new ScreenplayAIService();
